import { cartPricesAsOf } from '@share-a-cart/shared-utils';
import { useTranslation } from 'react-i18next';
import type { CartGetItem } from 'src/types';
import { VendorListAndPriceDisc } from '../cart';

type Props = {
  cartItems: CartGetItem[];
  cartVendor: string;
  cartTimestamp: number;
  cartStore: string;
};

export const ReceiveCartItemsHeader = ({
  cartItems = [],
  cartVendor,
  cartTimestamp,
  cartStore,
}: Props) => {
  const { t } = useTranslation();
  const itemTotal = cartItems.length;
  const itemsInCart = t('receive.items_in_cart', { count: itemTotal });

  return (
    <div className='mx-auto flex w-full max-w-[1440px] flex-row flex-wrap items-center justify-between gap-4 px-8 py-6 md:px-10'>
      <p className='heading-200'>{itemsInCart}</p>

      {/* Need to wrap this in a div to prevent the block from growing to the full width of the container */}
      <div className='ml-auto flex w-fit items-center justify-center'>
        <VendorListAndPriceDisc
          timestamp={cartPricesAsOf({ timestamp: cartTimestamp, items: cartItems }) ?? 0}
          itemCount={itemTotal}
          cartVendor={cartVendor}
          cartStore={cartStore}
          includeMarginRight={false}
        />
      </div>
    </div>
  );
};
